import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Amenity from "./Amenity";
import { Grid } from "semantic-ui-react";
import styles from "./styles.less";

class Amenities extends Component {
  normalizeAmenities = () => {
    const { amenities, isRtl } = this.props;
    if (!amenities) return [];
    const normalizedResult = amenities.reduce((result, amenity) => {
      const tempObj = {};
      tempObj["name"] = isRtl ? amenity.heb : amenity.eng;
      tempObj["code"] = amenity.code.toLowerCase();
      tempObj["sort"] = amenity.sort;
      result.push(tempObj);
      return result;
    }, []);

    return normalizedResult;
  };

  render() {
    const { amenities, isRtl, includeName, spaced, isntPreview } = this.props;
    const normalizedAmenities = this.normalizeAmenities(amenities);
    return (
      <Grid
        centered
        textAlign="center"
        className={cx(styles.amenities, { [styles.amenitiesSpaced]: spaced })}
      >
        <Grid.Row>
          {normalizedAmenities
            .sort((a1, a2) => a1.sort - a2.sort)
            .map((amenity, idx) => (
              <Grid.Column
                key={idx}
                className={styles.amenitiesRow}
                mobile={isntPreview ? 5 : 3}
                tablet={3}
                computer={3}
              >
                <Amenity
                  key={idx}
                  isRtl={isRtl}
                  {...amenity}
                  includeName={includeName}
                />
              </Grid.Column>
            ))}
        </Grid.Row>
      </Grid>
    );
  }
}

Amenities.defaultProps = {
  amenities: [],
  titles: {},
  includeName: false,
  isntPreview: false
};

Amenities.propTypes = {
  isRtl: PropTypes.bool,
  amenities: PropTypes.array,
  titles: PropTypes.object,
  includeName: PropTypes.bool,
  spaced: PropTypes.bool,
  isntPreview: PropTypes.bool
};

export default Amenities;



// WEBPACK FOOTER //
// ./src/components/common/Amenities/Amenities.js